var map = {
	"./18.png": 76340,
	"./android-icon.png": 22294,
	"./footer.png": 28734,
	"./game1.png": 84956,
	"./game10.png": 71974,
	"./game2.png": 92535,
	"./game3.png": 9390,
	"./game4.png": 7873,
	"./game5.png": 86744,
	"./game6.png": 82355,
	"./game7.png": 50442,
	"./game8.png": 77565,
	"./game9.png": 56436,
	"./ios-icon.png": 90244,
	"./pagcor.png": 38611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49620;